// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"8efb87ad","129":"0cfeab10","293":"dc77a3b7","358":"71571ab7","527":"88dc7b95","851":"ffb1c171","936":"7ef1acf1","970":"695cc61f","975":"2352419a"}[chunkId] + ".css";
};